import { render, staticRenderFns } from "./BookingPreviewMock.vue?vue&type=template&id=532004e5&scoped=true"
import script from "./BookingPreviewMock.vue?vue&type=script&lang=js"
export * from "./BookingPreviewMock.vue?vue&type=script&lang=js"
import style0 from "./BookingPreviewMock.vue?vue&type=style&index=0&id=532004e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532004e5",
  null
  
)

export default component.exports